export default __webpack_public_path__ + "static/media/nftuser.bb7f183c.jpeg";